import { render, staticRenderFns } from "./product-category-edit-modal.vue?vue&type=template&id=5169d274&scoped=true&"
import script from "./product-category-edit-modal.vue?vue&type=script&lang=js&"
export * from "./product-category-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-category-edit-modal.vue?vue&type=style&index=0&id=5169d274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169d274",
  null
  
)

export default component.exports